import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import ServiceWorkerUpdatePopup from '@/pwa/components/ServiceWorkerUpdatePopup.vue';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    _classCallCheck(this, default_1);
    return _callSuper(this, default_1, arguments);
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1);
}(Vue);
default_1 = __decorate([Component({
  name: 'App',
  components: {
    ServiceWorkerUpdatePopup: ServiceWorkerUpdatePopup
  }
})], default_1);
export default default_1;